import React, { useContext } from 'react';
import c from 'classnames';
import { CommentContext } from '../../CommentContext';
import AuthorUserLink from '../AuthorUserLink';
import CommentTimestamp from '../CommentTimestamp';
import FeaturedTag from '../FeaturedTag';
import s from './BylineBlock.scss';
/**
 * A user link, a timestamp, and a "Featured" tag if the comment is featured.
 *
 * We tend to add this just before the text content of a comment.
 * */
var BylineBlock = function (_a) {
    var className = _a.className;
    var comment = useContext(CommentContext).comment;
    var isFeatured = comment.isFeatured, user = comment.user;
    return (React.createElement("div", { className: c(s['root'], className) },
        user && React.createElement(AuthorUserLink, { comment: comment, className: s['userlink'] }),
        React.createElement(CommentTimestamp, { className: s['timestamp'] }),
        isFeatured && React.createElement(FeaturedTag, null)));
};
BylineBlock.displayName = 'BylineBlock';
export default BylineBlock;
//# sourceMappingURL=BylineBlock.js.map